import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from './../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号', width: 75},
    {key:'employeeCode', label: '职工号', width: 100},
    {key:'loginName', label: '登陆账号', width: 100},
    {key:'realName', label: '姓名', width: 90},
    {key:'sex', label: '性别', width: 80, render: (value) => value === 1 ? '男' : '女'},
    {key:'titleDegree', label: '职称等级', width: 100},
    {key:'title', label: '职称', width: 80},
    {key:'roleName', label: '角色', width: 100},
    {key:'orgXzName', label: '行政部门', width: 150},
    {key:'orgName', label: '评价部门', width: 100},
    {key:'tel', label: '联系电话', width: 120},
    {key:'birthday', label: '生日', width: 90, render: (value)=> value ?  moment(new Date(value)).format('YYYY/MM/DD') : "" },
    {key:'email', label: '邮箱', width: 100},
    {key:'teacherPropertyName', label: '教师性质', width: 90},
    {key:'isEval', label: '是否参评', width: 90, render: (value) => +value === 1 ? '参评' : '不参评'},
    {key:'professionalField', label: '专业领域', width: 90},
    {key:'researchDirection', label: '研究方向', width: 90},
    {
        key: 'retireFlag', 
        label: '是否退休', 
        render: (value) => {
            if (value === 1) {
                return '是';
            } else if (value === 2) {
                return '否'
            }
            return '';
        }
    }
]);

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByName = (keywords ={}) => {
    return fetch.post('employee/find/by/realname', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.employeeId,
            employeeNo: d.loginName,
            label: d.doubleName? (d.realName+" ("+d.employeeCode+","+d.orgName+"）"):(d.realName),
        }));
    });
}

/**
 * @method querySearchByNameInTargetInsert(指标录入页面职工下拉)
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByNameInTargetInsert = (keywords ={}) => {
    return fetch.post('employee/find/by/realname', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.employeeId,
            employeeNo: d.loginName,
            label: d.doubleName? (d.haveClasses == 1 ?(d.realName+" ("+d.employeeCode+","+d.orgName+",有课表）"):(d.realName+" ("+d.employeeCode+","+d.orgName+",无课表）")):d.haveClasses == 1 ?(d.realName+"（有课表）"):(d.realName+"（无课表）"),
        }));
    });
}

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByNameNew = (keywords ={}) => {
    return fetch.post('employee/find/by/name', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.employeeId,
            employeeNo: d.loginName,
            label: d.doubleName?d.realName+" ("+d.employeeCode+")":d.realName,
        }));
    });
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('employee/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

const getIsSuperAdmin = () => {
    return fetch.get('employee/getIsSuperAdmin', {})
    .then(response => response.payload.data)
    .catch(error => {
        
    });
}

const getOrgData = () => {
    return fetch.get('employee/getOrgData', {})
    .then(response => response.payload.data)
    .catch(error => {
        
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('employee/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.employeeId,
            checked: false,
            name: d.realName
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchByDudao = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('employee/find/dudao', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.employeeId,
            checked: false,
            name: d.realName
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

//employee/find/dudao;


const queryRoleList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('role/listAll', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: d.roleId,
                label: d.roleName
            }
        });
    });
}


const queryRoleListByName = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('role/listByName', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: d.roleId,
                label: d.roleName
            }
        });
    });
}

const queryPropertiesList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/employee/property', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryDegreeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/employee/degree', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: d.codeName,
                label: d.codeName
            }
        });
    });
}

const queryTitleList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/employee/title', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: d.codeName,
                label: d.codeName
            }
        });
    });
}

const queryTitleDegree = () => {
    return fetch.post('platform/code/employee/titleDegree')
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: d.codeId,
                label: d.codeName
            }
        });
    });
}

const queryTitleByPid = (pid) => {
    return fetch.post('platform/code/employee/title2/' + pid)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: d.codeId,
                label: d.codeName
            }
        });
    });
}


/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('employee/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                okText:"确认",
                onOk() {
                    DataGrid.selections = [];
                },
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('employee/update/' + id, data)
    .then(response => {
        if (response.code === 200) {
            Modal.success({
                title: '提示信息',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                okText:"确认",
                onOk() {
                    DataGrid.selections = [];
                },
            });
        }
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('employee/remove/', ids)
    .then(response => {
        return response;
    });
}


/**
 * @method remove
 * @param {array} data [id: int, ...]
 * @return {promise}
 */
const setUserPassword = (data) => {
    return fetch.post('employee/reset/pwd', data)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.selectData = [];
                                DataGrid.refresh();
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method setUserPwd
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const setUserPwd = (domain) => {
    const data = {
        pwdType: domain.pwdType,
        loginName: domain.loginName,
        employeeIds: domain.setAllPwd === true ? [] : DataGrid.selections,
        newPwd: domain.newPwd
    }

    setUserPassword(data).then(response => {
        if(response.code === 200) {
            message.success(response.message);
            DataGrid.selections = [];
            DataGrid.selectData = [];
            DataGrid.refresh();
        }
    });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'employee'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    }else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

export default {
    insertURL: '#/employee/insert',
    querySearchByName,
    querySearchByNameInTargetInsert,
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    columns,
    onSelect,
    onSelectData,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    getSelectionData,
    queryRoleList,
    queryPropertiesList,
    queryDegreeList,
    queryTitleList,
    querySearchByDudao,
    setUserPwd,
    querySearchByNameNew,
    getIsSuperAdmin,
    queryRoleListByName,
    getOrgData,
    queryTitleDegree,
    queryTitleByPid
}